const $pageNav = $('#page-navigation');
if ($pageNav.length) {
	$('.anchor').each(function(){
		$pageNav.append(`<li><a href="#${$(this).attr('id')}">${$(this).data('label')}</a></li>`)
	});
}